import { DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import { dateOnly, double, InferSubmit, mixed, object, text } from '@if/core/yup'
import { EFeeType, VALID_FEE_TYPES } from '@src/types/constants'

/**
 * The add form's fields, so the two dialogs read the same. The type is shown but not edited: a fee keeps its type.
 * A fee can be moved anywhere from the loan activation to today, never into the future. It cannot be set to 0: it is
 * removed by cancelling it from its calendar row, and the message says so.
 */
export const getEditFeeSchema = (activationDate: DateOnly, today: DateOnly) =>
  object({
    feeType: mixed<EFeeType>().oneOf(VALID_FEE_TYPES).required(),
    // min(0) lets 0 through so that only the not-zero message, which points to the cancel action, shows for it.
    amount: double()
      .required()
      .min(0)
      .test(
        'not-zero',
        () => t('loan.feesDialog.errors.amountZeroCancelInstead'),
        (value) => value !== 0,
      ),
    effectiveDate: dateOnly()
      .required()
      .min(activationDate, () => t('loan.feesDialog.errors.effectiveDateBeforeActivation'))
      .max(today, () => t('loan.feesDialog.errors.effectiveDateAfterToday')),
    note: text(),
  })

export type EditFeeSchemaType = InferSubmit<ReturnType<typeof getEditFeeSchema>>
